import { useRef } from 'react'
import { ConfirmationDialog, ConfirmationDialogRef, Glyphs, WidgetMicroButton } from '../../../../rapid-ui'
import { useLayerTreeActions } from '../../use-layer-tree-actions'

export function DeleteLayerButton({ layerId }: { layerId: string }) {
	const { deleteLayer } = useLayerTreeActions()
	const confirmRef = useRef<ConfirmationDialogRef>(null)

	async function handleDelete() {
		try {
			await confirmRef.current?.confirm({
				title: 'Delete layer',
				message: 'Are you sure you want to delete this layer? This cannot be undone.',
				confirmText: 'Delete',
			})
			deleteLayer(layerId)
		} catch {
			// cancelled
		}
	}

	return (
		<>
			<WidgetMicroButton variant="naked" title="Delete layer" onClick={handleDelete}>
				<Glyphs.core.DeleteIcon />
			</WidgetMicroButton>
			<ConfirmationDialog ref={confirmRef} />
		</>
	)
}
